export default function Logo({ light = false }) {
  const ink = light ? "#FAF7F2" : "#09090B";
  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <svg width="40" height="40" viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="32" r="29" fill="none" stroke="#B89742" strokeWidth="2" />
        <circle cx="32" cy="32" r="23.5" fill="none" stroke="#B89742" strokeWidth="0.75" opacity="0.6" />
        <circle cx="32" cy="7" r="2" fill="#E8A5B8" />
        <text x="32.5" y="42" textAnchor="middle" fontFamily="Playfair Display, Georgia, serif" fontStyle="italic" fontSize="30" fill={ink}>B</text>
      </svg>
      <span className="leading-tight">
        <span className={`block font-elegant italic text-xl md:text-2xl tracking-wide ${light ? "text-cream" : "text-ink"}`}>
          The Brides of India
        </span>
        <span className="block text-[9px] uppercase tracking-[0.35em] text-gold mt-0.5">
          Est. 2011 · Mumbai
        </span>
      </span>
    </span>
  );
}
